import React from "react";
import { Route, Redirect } from "react-router-dom";
import { AppLayout } from "./AppLayout";
import { isAuthenticated, parseStoredUser } from "../_helpers/auth";

export const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      if (!isAuthenticated()) {
        return (
          <Redirect
            to={{ pathname: "/login", state: { from: props.location } }}
          />
        );
      }

      const user = parseStoredUser();

      if (user && user.role && user.role != 2) {
        return (
          <div className="privateWindow">
            <AppLayout
              users={localStorage.getItem("user")}
              component={<Component {...props} />}
            ></AppLayout>
          </div>
        );
      }

      if (user && user.role && user.role === "2") {
        if (
          props.location.pathname.indexOf("ProfessionalForm") != -1 ||
          props.location.pathname === "/" ||
          props.location.pathname.indexOf("profile") != -1 ||
          props.location.pathname.indexOf("aboutCIMS") != -1 ||
          props.location.pathname.indexOf("reportAdminSpotvise") != -1 ||
          props.location.pathname.indexOf("spotservellience") != -1 ||
          props.location.pathname.indexOf("reportPlus2Report") != -1 ||
          props.location.pathname.indexOf("reportPoliceSpotvise") != -1 ||
          props.location.pathname.indexOf("reports4") != -1 ||
          props.location.pathname.indexOf("reports5") != -1 ||
          props.location.pathname.indexOf("reports") != -1 ||
          props.location.pathname.indexOf("reports3") != -1 ||
          props.location.pathname.indexOf("reportArrest") != -1 ||
          props.location.pathname.indexOf("reportAppUsers") != -1 ||
          props.location.pathname.indexOf("gps") != -1 ||
          props.location.pathname.indexOf("samans") != -1 ||
          props.location.pathname.indexOf("document-verification") != -1 ||
          props.location.pathname.indexOf("faq") != -1 ||
          props.location.pathname.indexOf("login_details") != -1 ||
          props.location.pathname.indexOf("AppUserLogin") != -1 ||
          props.location.pathname.indexOf("users") != -1 ||
          props.location.pathname.indexOf("finds") != -1 ||
          props.location.pathname.indexOf("preventive-notification") != -1 ||
          props.location.pathname.indexOf("reportPreventive") != -1 ||
          props.location.pathname.indexOf("guna-report") != -1 ||
          props.location.pathname.indexOf("add-crime") != -1 ||
          props.location.pathname.indexOf("ncr") != -1 ||
          props.location.pathname.indexOf("gang-details") != -1 ||
          props.location.pathname.indexOf("modas") != -1 ||
          props.location.pathname.indexOf("suggestion-feedback") != -1 ||
          props.location.pathname.indexOf("api-details") != -1 ||
          props.location.pathname.indexOf("map-cities") != -1 ||
          props.location.pathname.indexOf("sub-cities") != -1 ||
          props.location.pathname.indexOf("api-log") != -1 ||
          props.location.pathname.indexOf("logs") != -1 ||
          props.location.pathname.indexOf("News") != -1 ||
          props.location.pathname.indexOf("wanted") != -1 ||
          props.location.pathname.indexOf("help") != -1 ||
          props.location.pathname.indexOf("aboutus") != -1 ||
          props.location.pathname.indexOf("CCTVLocation") != -1 ||
          props.location.pathname.indexOf("Notifications") != -1 ||
          props.location.pathname.indexOf("act-section") != -1 ||
          props.location.pathname.indexOf("postman-collection") != -1 ||
          props.location.pathname.indexOf("api-manager") != -1 ||
          props.location.pathname.indexOf("gang-search") != -1 ||
          props.location.pathname.indexOf("daily-repots") != -1 ||
          props.location.pathname.indexOf("new-dashboard") != -1 ||
          props.location.pathname.indexOf("guna-hide") != -1 ||
          props.location.pathname.indexOf("admin-new-dashboard") != -1 ||
          props.location.pathname.indexOf("face-search-allocation") != -1 ||
          props.location.pathname.indexOf("find-face-search") != -1 ||
          props.location.pathname.indexOf("map-police-station") != -1 ||
          props.location.pathname.indexOf("states") != -1 ||
          props.location.pathname.indexOf("cctns-districts-map") != -1 ||
          props.location.pathname.indexOf("notice-report") != -1 ||
          props.location.pathname.indexOf("fuzzy") != -1 ||
          props.location.pathname.indexOf("douable-cr") != -1 ||
          props.location.pathname.indexOf("crime-null") != -1 ||
          props.location.pathname.indexOf("cctns-city") != -1 ||
          props.location.pathname.indexOf("cctns-missing-report") != -1 ||
          props.location.pathname.indexOf("cctns-missing") != -1 ||
          props.location.pathname.indexOf("aropi-count") != -1 ||
          props.location.pathname.indexOf("image-map") != -1
        ) {
          return (
            <div className="privateWindow">
              <AppLayout
                users={localStorage.getItem("user")}
                component={<Component {...props} />}
              ></AppLayout>
            </div>
          );
        }

        return (
          <Redirect
            to={{ pathname: "/login", state: { from: props.location } }}
          />
        );
      }

      return (
        <div className="privateWindow">
          <AppLayout
            users={localStorage.getItem("user")}
            component={<Component {...props} />}
          ></AppLayout>
        </div>
      );
    }}
  />
);
